import { DiscordIcon, TelegramIcon, XIcon } from "@/components/icons";
import { SOCIALS } from "@/constants/socials";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/profile/contact")({
	component: ProfileContact,
});

function SocialCard({
	href,
	icon,
	iconBg,
	desc,
}: {
	href: string;
	icon: React.ReactNode;
	iconBg: string;
	desc: string;
}) {
	return (
		<a
			href={href}
			target="_blank"
			rel="noreferrer"
			className="flex flex-col items-center relative"
		>
			<div
				className={`absolute top-0 -translate-y-1/2 ${iconBg} w-[55px] h-[55px] flex items-center justify-center rounded-full`}
			>
				{icon}
			</div>
			<div className="w-[240px] min-h-[119px] flex items-center justify-center p-[35px] pt-[44px] text-center text-t2 rounded-[20px] bg-bg1 text-sm font-medium shadow">
				{desc}
			</div>
		</a>
	);
}

const SOCIAL_ICONS = {
	X: <XIcon className="w-7 [&>path]:fill-w1" />,
	Discord: <DiscordIcon className="w-7 h-auto fill-[#5965f2]" />,
	Telegram: <TelegramIcon className="w-7" />,
};

function ProfileContact() {
	const _socials = SOCIALS.map((item) => ({
		href: item.href,
		icon: SOCIAL_ICONS[item.name as keyof typeof SOCIAL_ICONS],
		iconBg: item.name === "X" ? "bg-w2" : "bg-bg2",
		desc: item.desc,
	}));

	return (
		<div className="flex justify-center items-center min-h-100 max-md:px-4 max-md:pt-14">
			<div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-12 w-full max-w-[801px] max-md:grid-cols-1">
				{_socials.map((item) => (
					<SocialCard key={item.href} {...item} />
				))}
			</div>
		</div>
	);
}
